import React, { useEffect, useRef, useState } from "react";
import { setDangerousHtml } from "src/utils";

import { GenericFeed } from "..";

export const CustomComponent = props => {
  const { template, placeholder = <GenericFeed count={6} />, maxTime = 1000 } = props;

  const ref = useRef();
  const [mutated, setMutated] = useState(false);

  useEffect(() => {
    const mutate = () => !mutated && setMutated(true);

    if (!mutated) {
      setDangerousHtml(template)(ref.current);
      const timeout = setTimeout(mutate, maxTime);
      const observer = new MutationObserver(mutate);

      observer.observe(ref.current, { attributes: true, childList: true, subtree: true });

      return () => {
        clearTimeout(timeout);
        observer.disconnect();
      };
    }
  }, [mutated, maxTime, template]);

  return (
    <>
      <div ref={ref} class={template.includes("cse") ? 'search-results' : ""} style={{ opacity: mutated ? "1" : "0" }}></div>
      {!mutated ? placeholder : null}
    </>
  );
};
